import { Component, Input, OnInit } from '@angular/core';
import { ICombinedReplaceIdStatistic } from 'src/app/shared/interfaces/combined-replace-id-statistic.interface';

@Component({
    standalone: false,
    selector: 'app-replaced-land-use-ids-list',
    templateUrl: './replace-land-use-ids-list.component.html',
    styleUrls: ['./replace-land-use-ids-list.component.scss', '../../../../../../shared/styles/mdl-table.scss']
})
export class ReplaceLandUseIdsListComponent implements OnInit {
    @Input()
    combinedReplaceIdStatistics: ICombinedReplaceIdStatistic[];

    constructor() {}

    ngOnInit(): void {}
}
